import React from "react";
import { cn } from "../../u1/cn";

/* Static support card on the claim intake's right rail.
 *
 * A real mailto: rather than styled text — someone stuck on the form should be
 * one click from a message, not left to copy an address out by hand.
 */
export const NeedHelp = ({
  title = "Need help?",
  email = "support@trevex.io",
  children = "with your trade license and we'll do the rest.",
  className = "",
}) => (
  <section
    aria-labelledby="need-help"
    className={cn("rounded-xl bg-[var(--navy)] p-5 text-white", className)}
  >
    <h2 id="need-help" className="text-[14px] font-bold font-sans">
      {title}
    </h2>
    <p className="mt-1.5 text-[13px] leading-[1.5] text-[var(--owner-body)] font-sans">
      Email{" "}
      <a
        href={`mailto:${email}`}
        className="border-b border-dashed border-[var(--owner-body)] text-white hover:border-solid focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
      >
        {email}
      </a>{" "}
      {children}
    </p>
  </section>
);

export default NeedHelp;
